import { api } from '../api/client';
import { API_COLLECTIONS_URL } from '../utils';

/** Items per page of the grouped search, across all cards (the server's default is 20, its ceiling 50). */
export const COLLECTION_SEARCH_LIMIT = 20;

/**
 * `GET /api/collections/{id}/search` (keepr-api docs/SCHEMA.md, "Search inside
 * a collection"): cards by name, items by their text, each card once with its
 * matching items under it. `cursor` is the previous page's `nextCursor`.
 */
export async function searchCollection(collectionId, { q, cursor = null, limit = COLLECTION_SEARCH_LIMIT, scope } = {}, config = {}) {
	const params = { q, limit };
	if (cursor) params.cursor = cursor;
	if (scope) params.scope = scope;
	const { data } = await api.get(`${API_COLLECTIONS_URL}/${collectionId}/search`, { ...config, params });
	return data;
}
